import { useEffect, useState } from "react";

interface UseUnifiedSyncOptions {
  maxWaitTime?: number;
  maxInterval?: number;
  initialInterval?: number;
  functionName?: string;
}
export const useUnifiedSync = (options?: UseUnifiedSyncOptions) => {
  const {
    maxWaitTime = 10000,
    maxInterval = 2000,
    initialInterval = 100,
    functionName = "GetCachedUnifiedSync",
  } = options || {};
  const [isUnifiedSyncReady, setIsUnifiedSyncReady] = useState<boolean>(false);
  const [attemptCount, setAttemptCount] = useState<number>(0);

  useEffect(() => {
    let attempt = 0;
    let currentInterval = initialInterval;
    let totalWaitTime = 0;
    let timeoutId: NodeJS.Timeout;
    const checkUnifiedSync = (): boolean => {
      const windowFunction = (window as any)?.[functionName];
      if (windowFunction && typeof windowFunction === "function") {
        setIsUnifiedSyncReady(true);
        return true;
      }
      return false;
    };

    const scheduleNextCheck = (): void => {
      if (totalWaitTime >= maxWaitTime) {
        console.warn(
          `${functionName} not available after ${maxWaitTime / 1000} seconds, stopping checks`
        );
        return;
      }
      timeoutId = setTimeout(() => {
        if (checkUnifiedSync()) {
          return;
        }

        attempt++;
        setAttemptCount(attempt);
        totalWaitTime += currentInterval;
        currentInterval = Math.min(currentInterval * 2, maxInterval);
        scheduleNextCheck();
      }, currentInterval);
    };
    if (!checkUnifiedSync()) {
      scheduleNextCheck();
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [maxWaitTime, maxInterval, initialInterval, functionName]);

  return {
    isUnifiedSyncReady,
    attemptCount,
  };
};
